import React from 'react'
import { motion } from 'framer-motion'
import { StyleAppShowCaseCardWrapper } from './style'

const imageData = [
  '/phones/appView/supcharLogoPhoneView.svg',
  '/phones/appView/User_home.svg',
  '/phones/appView/Search.svg',
  '/phones/appView/Search-Doctor.svg',
  '/phones/appView/Search-Lab-Test.svg',
  '/phones/appView/User_home.svg',
  '/phones/appView/Search-Doctor.svg',
  '/phones/appView/Search-Lab-Test.svg',
  '/phones/appView/Search.svg',
]

const MotionShowcaseWrapper = motion(StyleAppShowCaseCardWrapper)

const AppShowCaseSlider = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        when: 'beforeChildren',
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
    hover: {
      x: 2,
      y: -2,
      boxShadow: '0px 10px 20px rgba(0,0,0,0.1)',
      transition: {
        type: 'spring',
        stiffness: 150,
        damping: 12,
        duration: 0.3,
      },
    },
  }

  return (
    <MotionShowcaseWrapper
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '0px 0px -100px 0px' }}
      style={{ overflow: 'hidden', display: 'flex', width: '100%' }}
    >
      <motion.div
        style={{ display: 'flex', willChange: 'transform' }}
        animate={{
          x: ['0%', '-100%'], 
        }}
        transition={{
          duration: 100,
          repeat: Infinity,
          ease: 'linear',
        }}
      >
        {[...imageData, ...imageData].map((imgSrc, idx) => (
          <motion.img
            key={idx}
            src={imgSrc}
            alt=""
            variants={itemVariants}
            whileHover="hover"
            style={{
              borderRadius: '10px',
              padding: '10px',
              marginRight: '15px',
              width: 'auto', 
            }}
          />
        ))}
      </motion.div>
    </MotionShowcaseWrapper>
  )
}

export default AppShowCaseSlider
